import { AppLocale, fallbackLocale, hasLocale, localeCookieName } from './locales';

type Messages = typeof import('../../messages/en.json');

export async function getMessages(locale: AppLocale): Promise<Messages> {
  switch (locale) {
    case 'en':
      return (await import('../../messages/en.json')).default;
    case 'pt-BR':
    default:
      return (await import('../../messages/pt-BR.json')).default;
  }
}

export function getLocaleFromCookie(): AppLocale {
  if (typeof document === 'undefined') {
    return fallbackLocale;
  }

  const cookie = document.cookie
    .split('; ')
    .find((entry) => entry.startsWith(`${localeCookieName}=`));

  if (!cookie) {
    return fallbackLocale;
  }

  const value = decodeURIComponent(cookie.split('=').slice(1).join('='));

  if (hasLocale(value)) {
    return value;
  }

  return fallbackLocale;
}

const locales: Record<string, Messages> = {};

export async function getCurrentMessages() {
  const locale = getLocaleFromCookie();
  if (locales[locale]) return locales[locale];

  locales[locale] = await getMessages(locale);
  return locales[locale];
}
